<template>
  <div class="main-wrapper">
    <div class="content main_content">
      <side-menu></side-menu>

      <operator-sidebar v-if="isOperator"></operator-sidebar>

      <chat-sidebar :class="{'sidebar-border-l-0': isOperator}"></chat-sidebar>

      <div class="chat status-middle-bar d-flex align-items-center justify-content-center">
        <div class="status-right px-3">

          <div v-if="!isOperator" class="select-message-box">
            <div v-if="subscriptionExpired">
              <h1>{{$t('trial_subscription_expired')}}</h1>

              <p>{{$t('chat_subscription_expired_subtitle')}}</p>

              <router-link
                to="/subscription"
                class="btn btn-primary"
              >
                {{$t('chat_trial_upgrade_now')}}
                <i class="fas fa-arrow-right ms-2"></i>
              </router-link>
            </div>

            <div v-else>
              <h1>{{$t('chat_discover_title')}}</h1>

              <p>{{$t('chat_discover_subtitle')}}</p>

              <router-link
                to="/discover"
                class="btn btn-primary"
              >
                {{$t('chat_discover_button')}}
                <i class="fas fa-arrow-right ms-2"></i>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  computed: {
    ...mapGetters({
      isOperator: 'isOperator',
      subscriptionExpired: 'subscriptions/expired',
    }),
  },
}
</script>
